import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_GROUP_LESSON_AWARDS_REQUEST = 'FETCH_GROUP_LESSON_AWARDS_REQUEST';
export const FETCH_GROUP_LESSON_AWARDS_SUCCESS = 'FETCH_GROUP_LESSON_AWARDS_SUCCESS';
export const FETCH_GROUP_LESSON_AWARDS_FAILURE = 'FETCH_GROUP_LESSON_AWARDS_FAILURE';

const buildSessionAwardsUrl = (sessionId) =>
  buildUrl(`/sessions/${sessionId}/hf-v4-awards`);

const HTTP_METHOD_GET = 'GET';

export function fetchGroupLessonAwardsIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    const url = buildSessionAwardsUrl(sessionId);
    if (! ApiCall.shouldPerform(state, { method: HTTP_METHOD_GET, url })) {
      return false;
    }

    return dispatch(fetchGroupLessonAwards(sessionId));
  };
}

export function fetchGroupLessonAwards(sessionId) {
  return (dispatch) => {
    const url = buildSessionAwardsUrl(sessionId);
    const method = HTTP_METHOD_GET;

    return dispatch(createRequestAction({ sessionId, method, url })).payload
      .then((response) => dispatch(createSuccessAction({ response, sessionId, method, url })))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(createSuccessAction({ sessionId, method, url }));
        }

        return dispatch(createFailureAction({ error, sessionId, method, url }));
      });
  };
}

function createRequestAction({ sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_REQUEST,
    payload: fetch(url),
    url,
    method,
    sessionId,
  });
}

function createSuccessAction({ response, sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_SUCCESS,
    payload: response,
    url,
    method,
    sessionId,
  });
}

function createFailureAction({ error, sessionId, method, url }) {
  return ApiCall.createAction({
    type: FETCH_GROUP_LESSON_AWARDS_FAILURE,
    payload: error,
    url,
    method,
    sessionId,
  });
}



// WEBPACK FOOTER //
// ./data/GroupLessonAwards/actions.js